import { useDispatch } from "react-redux";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { transformDraftToVariant } from "./transformers";
import { TiVoAppProvider } from "./types";

export const useProviders = (queryParams?: ApiQueryParams) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useQuery<ApiResponse<TiVoAppProvider[]>>({
    queryKey: ["providers", queryParams],
    queryFn: async () => {
      const data: ApiResponse<TiVoAppProvider[]> = await dispatch(
        apiThatThrows.getTiVoProviders.action({ queryParams })
      );

      data.results = data.results.map((provider) => {
        queryClient.setQueryData(["provider", provider.id], {
          results: provider,
        });

        if (provider.variants && provider.variantDraft) {
          const transformedDraft = transformDraftToVariant(
            provider.variantDraft
          );

          queryClient.setQueryData(["variantDraft", provider.id], {
            results: provider.variantDraft,
          });

          return {
            ...provider,
            variants: [transformedDraft, ...provider.variants],
          };
        }

        return provider;
      });

      return data;
    },
  });
};
